<template>
  <div class="news"  >
    <div class="inner-page-title">News & Events </div>
    <div v-show="posts" id="bg-animated" >

        <div id="fps"></div>

        <div id="bg_glow"></div>
        <div id="overlay"></div>
        <canvas id="canvas"></canvas>
    </div>
   
    <pre-post v-if="posts" :media="proxyUrl + posts[0].jetpack_featured_media_url" :post="posts[0]"></pre-post>
   <div style="color:white">

   </div>
    <div class="news_body"   v-if="posts">
      <div class="container">

        <div class="row">
          <!-- BODY PAGE -->
          <div class="col-md-9">
            <div class="row">
              <div class="col-md-7" data-aos="fade-up" data-aos-delay="500">
                <div class="posts_section">
                  <div class="page_section_header">
                    <h2>
                      News

                    </h2>
                    <p>
                   The more you read about the world around you, the more you're connected to the world. Get the latest news from around the world all in one place and start connecting today!
                    </p>
                  </div>
                  <div class="page_section_body" v-if="posts">
                    <!-- POST STYLE -->
                    <post data-aos="fade-up" data-aos-delay="100" data-aos-once="true" v-for="item in posts.slice(0,4)"
                      :post="item" :key="item.id" :categories="categories" :media="medias"></post>
                    <!--End POST STYLE -->
                    <router-link :to="'/news/overview/posts'" class=" button button--transparent-grad pulse">
                      <span>
                        See more
                      </span>
                    </router-link>

                  </div>
                </div>

              </div>
              <div class="col-md-5" data-aos="fade-up" data-aos-delay="300">
                <div class="page_section_header sm-p-23">
                  <div class="page_section_header__title">
                  <h2>
                    Events
                  </h2>
                    <router-link :to="'/events' " class="events-btn button button--transparent-grad pulse">
                        <span>
                        Events calendar
                        </span>
                    </router-link>
                  </div>
                  <p>
                    Business events are vital for raising brand awareness and connecting with clients on a personal level. Meeting with your clients face to face is the most effective approach to establish trust and demonstrate that they are your top priority.
                  <br><br>
                  Take a look at the events list we’re planning to attend!
                  </p>
                </div>
                <div class="events">
                  <router-link data-aos="fade-up" data-aos-once="true" data-aos-delay="100" data-aos-duration="500"
                    :to="'/news/show/'+ event.id + '/events'" class="events__event" v-for="event in events"
                    :key="event.id">
                    <div class="events__event__date">
                      <p class="events__event__date__day"> {{ event.date | moment("DD ") }} </p>
                      <p class="events__event__date__month">{{ event.date | moment("MMMM ") }} </p>
                    </div>
                    <div class="events__event__info">
                      <h3 v-html="event.title.rendered">
                      </h3>
                      <div class="events__event__info__cloud">
                        <img
                          src="/static/cdn/location_wqviie.svg">
                        <span v-html="event.excerpt.rendered"> </span>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>

            <div class="row" v-if="blog && blog.length"> 
              <div class="col-md-12">
                <div class="posts_section mt-10">
                  <div class="page_section_header">
                    <h2>
                      Blog
                    </h2>
                    <p>
                      Blogging isn’t just about publishing random words; it’s about unleashing creativity into the universe. Because we’re huge supporters of unleashing creativity, we’ve creating the most exciting blogs just for you. Enjoy!
                    </p>
                  </div>
                  <div class="page_section_body" v-if="posts">
                    <div class="row">
                      <div class="col-sm-4 col-xs-12" v-for="item in blog">
                        <post data-aos="fade-up" typepost="col" data-aos-delay="100" data-aos-once="true" 
                      :post="item" :key="item.id" :categories="categories" :media="medias"></post>
                      </div>
                    </div>
                    <!-- POST STYLE -->
                    <p></p>
                    <!--End POST STYLE -->
                    <router-link :to="'/news/overview/blog'" class=" button button--transparent-grad pulse">
                      <span>
                        See more
                      </span>
                    </router-link>

                  </div>
                </div>

              </div>
            </div>

          </div>

          <!-- SIDE PAGE -->
          <div class="col-md-3 col-xs-12">
            <side-bare></side-bare>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

  import global from '@/mixins/global';
  import GPost from '@/mixins/posts';

  export default {
    mixins: [global,GPost],

   async created() {
     await this.getCategories();
     await  this.getPosts();
     await this.getEvents();
     await this.getBlog();
    },
    mounted() {
        var canvas = document.getElementById("canvas");
        var ctx = canvas.getContext("2d");
        var bgg = document.getElementById("bg_glow");
        var w = ctx.canvas.width = window.innerWidth;
        var h = ctx.canvas.height = window.innerHeight;
          var dots = [];
        window.onresize = function() {
          w = ctx.canvas.width = window.innerWidth;
          h = ctx.canvas.height = window.innerHeight;
          maxHeight = h*.9
          minHeight = h*.5;
          dots = [];
          pushDots();
          ctx.globalCompositeOperation = "lighter";
        };

            // document.getElementById("overlay").onclick = function(){
            //   hue = 115*360;
            //   bgg.style.background = "radial-gradient(ellipse at center, hsla("+hue+",50%,50%,.8) 0%,rgba(0,0,0,0) 100%)";
            //   dots = [];
            //   pushDots();
            // }

            dots=[{}];
            var mx = 0;
            var my = 0;
            var md = 100;
            var maxWidth = 15;
            var minWidth = 2;
            var maxHeight = h*.9
            var minHeight = h*.5;
            var maxSpeed = 35;
            var minSpeed = 6;
            var hue = 490;
            var hueDif = 50; // Hue +/-
            var glow = 10; // Set to 0 for better performance
            ctx.globalCompositeOperation = "lighter";

            function pushDots(num){
              for(var i=1; i<md; i++){
                dots.push({
                  x:Math.random()*w,
                  y:Math.random()*h/2,
                  h:Math.random()*(maxHeight-minHeight)+minHeight,
                  w:Math.random()*(maxWidth-minWidth)+minWidth,
                  c:Math.random()*((hue+hueDif)-(hue-hueDif))+(hue-hueDif),
                  m:Math.random()*(maxSpeed-minSpeed)+minSpeed
                });
              }
            }pushDots();

            function render(){
              ctx.clearRect(0,0,w,h);
              for(var i=1; i<dots.length; i++){
                ctx.beginPath();
                var grd = ctx.createLinearGradient(dots[i].x, dots[i].y, dots[i].x+dots[i].w, dots[i].y+dots[i].h);
                grd.addColorStop(.0, "hsla("+dots[i].c+",50%,50%,.0)");
                grd.addColorStop(.2, "hsla("+dots[i].c+20+",50%,50%,.5)");
                grd.addColorStop(.5, "hsla("+dots[i].c+50+",70%,60%,.8)");
                grd.addColorStop(.8, "hsla("+dots[i].c+80+",50%,50%,.5)");
                grd.addColorStop(1., "hsla("+(dots[i].c+100)+",50%,50%,.0)");
                ctx.shadowBlur = glow;
                ctx.shadowColor = "hsla("+(dots[i].c)+",50%,50%,1)";
                ctx.fillStyle=grd;
                ctx.fillRect(dots[i].x,dots[i].y,dots[i].w,dots[i].h);
                ctx.closePath();
                dots[i].x += dots[i].m/100;
                if(dots[i].x > w+maxWidth){
                  dots.splice(i,1);
                  dots.push({
                    x:0,
                    y:Math.random()*h,
                    h:Math.random()*(maxHeight-minHeight)+minHeight,
                    w:Math.random()*(maxWidth-minWidth)+minWidth,
                    c:Math.random()*((hue+hueDif)-(hue-hueDif))+(hue-hueDif),
                    m:Math.random()*(maxSpeed-minSpeed)+minSpeed
                  });
                }
              }window.requestAnimationFrame(render);
            }

            bgg.style.background = "radial-gradient(ellipse at center, hsla("+hue+",50%,50%,.8) 0%,rgba(0,0,0,0) 100%)";

            render();
    },
   metaInfo: {
      title: 'News',
    },
  }

</script>
<style scoped>

#canvas{
  cursor: crosshair;
  z-index: 2;
  position: absolute;
  top: 0; left: 0;
}

#overlay{
  background: radial-gradient(ellipse at center, rgba(0,0,0,.0) 10%, rgba(0,0,0,.8) 80%, rgba(0,0,0,1) 90%, rgba(0,0,0,1) 100%);
  z-index: 3;
  position: absolute;
  top:0;left:0;
  height: 100%;
  width: 100%;
}

#bg_glow{
  z-index: 1;
  position: absolute;
  top:0;left:0;
  height: 100%;
  width: 100%;

}

#info{
  z-index: 4;
  position: absolute;
  color: #fff;
  top: 0px;
  left: 0px;
  background: rgba(60,60,60,.6);
  padding: 5px;
}
#overlay:hover{
  cursor: pointer;
}

#fps{
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 5;
}
</style>
<style lang="scss">
  .news {
    @import "../../assets/style/flexbox";
  }

  @import "./style";

</style>



// WEBPACK FOOTER //
// src/components/News/index.vue